<template>
<div id="cards-area" :class="`objects-row`">
        <div itemtype="http://schema.org/ListItem"  class="row justify-content-left" v-for="i in getCounter">
            <div v-for="object in getCardsForRow(i)" class="col-6" :class="getGridClass">
                <category-card :search-engine-type="searchEngineType" :object="object" :store="store"></category-card>
            </div>
        </div>
        <div v-if="!hideMessage  && objectsToShow && objectsToShow.length===0">
            <span>No results, please refine your search</span>
        </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import CategoryCard from './CategoryCard.vue';
import {DataLayer} from '../../../mixins/DataLayer';

export default {
    name: 'cards-area',
    mixins: [DataLayer],
    props: ['objectsToShow', 'store','searchEngineType'],
    components: {
        'category-card': CategoryCard,
    },
    data() {
        return {
            hideMessage: true,
        }
    },
    watch: {
        objectsToShow: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                if(newValue && newValue.length>0 && this.$route.name!=="diamonds-page-diamond-popup") this.sendGA();
                if(typeof oldValue!==undefined)
                    this.hideMessage=false;
            }
        },
    },
    computed: {
        ...mapState('willyou', [
            'categoriesToShoInARow'
        ]),
        getCounter() {
            return this.objectsToShow ? Math.ceil(this.objectsToShow.length / this.categoriesToShoInARow) : 1;
        },
        getGridClass() {
            return this.categoriesToShoInARow === 4 ? 'col-lg-3' : 'col-lg-4';
        },
    },
    methods: {
        getCardsForRow(i) {
            return this.objectsToShow ? this.objectsToShow.slice((i - 1) * this.categoriesToShoInARow , i * this.categoriesToShoInARow) : null ;
        },
    }
}
</script>

<style lang="scss" scoped>
</style>
